import styled, { css } from 'styled-components';

export const Container = styled.div<{
  $isFrozen: boolean;
  $isSelected: boolean;
  $isMoving: boolean;
  $isGrabbable: boolean;
}>`
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1.5)}`};

  border-radius: ${({ theme }) => theme.spacing(2.5)};
  transition: background 200ms;
  cursor: ${({ $isFrozen }) => ($isFrozen ? 'default' : 'pointer')};

  &:focus-visible {
    outline: none;
  }

  ${({ $isMoving, $isSelected, theme }) =>
    !$isMoving &&
    $isSelected &&
    css`
      background: ${theme.palette.primaryExtended.opacityBackgroundBackground};
    `};

  ${({ theme, $isGrabbable }) =>
    $isGrabbable &&
    css`
      &:hover {
        background: ${theme.palette.grey[50]};
      }
    `};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) =>
        `${theme.spacing(1.5)} ${theme.spacing(3)} ${theme.spacing(1.5)} ${theme.spacing(1)}`};
    `};
`;

export const Body = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  padding: ${({ theme }) => `0 0 0 ${theme.spacing(6.5)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding: ${({ theme }) =>
        `${theme.spacing(0.5)} 0 0 ${theme.spacing(9.5)}`};
    `};
`;
